import { Extension } from '@tiptap/core'
import Suggestion, { SuggestionOptions } from '@tiptap/suggestion'

export const Commands = Extension.create<{
  suggestion: Omit<SuggestionOptions, 'editor'>
}>({
  name: 'contextualMenu',
  group: 'inline',
  inline: true,

  addOptions() {
    return {
      ...this.parent?.(),
      suggestion: {
        char: '/',
        allowedPrefixes: null,
        command: ({ editor, range, props }) => {
          props.command({ editor, range })
        },
        allow: ({ editor, state, range }) => {
          return (
            !editor.isActive('figure') &&
            !editor.isActive('codeBlock') &&
            !editor.isActive('embed-preview')
          )
        },
      },
    }
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        ...this.options.suggestion,
        editor: this.editor,
      }),
    ]
  },
})
